import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { RequestListType } from "app/bundles/requests/shared/enums/request-list-type.enum";
import { IGeojsonRequest } from "app/bundles/requests/shared/models/geojsonRequest";
import { IconService } from "app/bundles/requests/shared/services/icon.service";
import { MapService } from "app/bundles/requests/shared/services/map.service";
import { CoreService } from "app/core/core.service";
import { StorageService } from "app/shared/services/storage.service";
import { Subscription } from "rxjs";
import { RequestApi } from "../shared/api-services/request-api/request-api.models";
import { Properties } from "../shared/models/properties";
import {
  IWorkorderOrServiceRequestSummary,
  RequestSourceTypeEnum,
} from "../shared/models/request";

@Component({
  selector: "app-request-map-list",
  templateUrl: "./request-map-list.component.html",
  styleUrls: ["./request-map-list.component.scss"],
})
export class RequestMapListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() requests: IWorkorderOrServiceRequestSummary[];
  private subscriptions = new Subscription();
  private geojsonData: IGeojsonRequest = null;
  private requestListType = RequestListType;
  private listType: RequestListType;
  public request: IWorkorderOrServiceRequestSummary;

  constructor(
    private requestApiService: RequestApi,
    private coreService: CoreService,
    private storageService: StorageService,
    private iconService: IconService,
    private mapService: MapService,
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.coreService.listType$.subscribe((listType: RequestListType) => {
        this.listType = listType;
        this.mapService.clearPopup();
        if (
          listType === this.requestListType.MAP ||
          listType === this.requestListType.BOTH
        ) {
          this.mapService.refreshMap();
        }
      }),
    );

    this.subscriptions.add(
      this.coreService.requestIconClicked$.subscribe(
        (requestProperties: Properties) => {
          this.request = null;
          const sessionListType: RequestListType = parseInt(
            this.storageService.getFilters().listType,
          );
          if (
            requestProperties &&
            (this.listType === this.requestListType.MAP ||
              sessionListType === this.requestListType.MAP)
          ) {
            setTimeout(
              () =>
                (this.request = {
                  ...this.request,
                  ...requestProperties,
                  source:
                    RequestSourceTypeEnum[requestProperties.source.toString()],
                }),
              10,
            );
          }
        },
      ),
    );
  }

  ngAfterViewInit(): void {
    this.mapService.buildMap();
    this.geojsonData = this.storageService.getGeoJsonRequest();
    this.mapService.updateGeojson(this.geojsonData);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
